export const generateQuizId = name => {
  const sanitized = name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
  return `${sanitized}_${require('uniqid')()}`;
};
